export default __webpack_public_path__ + "static/media/sticker-13.5e4e6cc2.png";